import React, { useEffect, useState } from "react";
import styles from "../../../../styles/scope3/Dashboard/purchaseGoods.module.css";
import { durationObj } from "../../../../utils/constant";
import BarChart from "../../../../Components/GraphNCharts/BarChart";
import LineChart from "../../../../Components/GraphNCharts/LineChart";
import TableChart from "../../../../Components/GraphNCharts/TableChart";
import GlobalChart from "../../../../Components/GraphNCharts/GlobalChart";
import { get } from "../../../../utils/api";
import {
  generateBarChartDataSetForWaste,
  manipulateDataForBarChart,
} from "../../../../utils/graphFunctions";
import EchartDoughnutChart from "../../../../Components/GraphNCharts/EchartDoughnut";
import PeriodFilter from "../../../../Components/Common/PeriodFilter";
import { generateMonthArray } from "../../../../utils/formatDate";
import {
  fixedPercentage,
  fixedTons,
  formatNumberCommaSeparated,
  truncateNumber,
} from "../../../../utils/common";
import { Box, Typography } from "@mui/material";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import useAuthStore from "../../../../store/ContextUser";
const Dashboard = () => {
  const currentDate = new Date();
  const { selectedCompany } = useAuthStore();

  const currentYear = currentDate.getFullYear();
  const [selectedFacility, setSelectedFacility] = useState([]);
  const [dashboardData, setDashboardData] = useState({
    emission: null,
    wasteGenerated: null,
    wasteType: null,
    wasteManagement: null,
    temporalAnalysis: null,
    emissionFacility: null,
    wasteRecycled: null,
    vendorWasteManaged: null,
  });
  const [error, setError] = useState(null);
  const [month, setMonth] = useState("1M");
  const [tableData, setTableData] = useState();
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const [graphView, setGraphView] = useState({
    facility: "",
    temporal: "Annual",
    vendor: "",
    totalWaterRecycled: "Year",
  });

  const [vendorList, setVendors] = useState([]);
  const [facilityList, setFacilities] = useState([]);

  const generateYearList = (startYear = 2020) => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = startYear; year <= currentYear; year++) {
      years.push(year);
    }
    return years;
  };
  const yearList = generateYearList(2020);

  const apiUrls = {
    emission: `/dashboard/scope3/wastegenerated/emission?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${
      selectedCompany?._id
    }`,
    wasteGenerated: `/dashboard/scope3/wastegenerated/waste-generated?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${
      selectedCompany?._id
    }`,
    wasteType: `/dashboard/scope3/wastegenerated/waste-type?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${
      selectedCompany?._id
    }`,
    wasteManagement: `/dashboard/scope3/wastegenerated/waste-management?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${
      selectedCompany?._id
    }`,
    temporalAnalysis: `/dashboard/scope3/wastegenerated/temporal-analysis?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${
      selectedCompany?._id
    }`,
    // emissionFacility: `/dashboard/scope3/wastegenerated/emission-facility?facility=${encodeURIComponent(
    //   graphView?.facility
    // )}`,
    wasteRecycled: `/dashboard/scope3/wastegenerated/waste-recycled?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${
      selectedCompany?._id
    }`,
  };

  const fetchData = async () => {
    try {
      const [
        emissionResult,
        wasteGeneratedResult,
        wasteTypeResult,
        wasteManagementResult,
        temporalAnalysisResult,
        // emissionFacilityResult,
        wasteRecycledResult,
      ] = await Promise.all([
        get(apiUrls.emission),
        get(apiUrls.wasteGenerated),
        get(apiUrls.wasteType),
        get(apiUrls.wasteManagement),
        get(apiUrls.temporalAnalysis),
        // get(apiUrls.emissionFacility),
        get(apiUrls.wasteRecycled),
      ]);

      setDashboardData({
        emission: emissionResult.data,
        wasteGenerated: wasteGeneratedResult.data,
        wasteType: wasteTypeResult.data,
        wasteManagement: wasteManagementResult.data,
        temporalAnalysis: temporalAnalysisResult.data,
        // emissionFacility: emissionFacilityResult.data,
        wasteRecycled: wasteRecycledResult.data,
      });
    } catch (err) {
      setError("Error fetching data: " + err.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, [fromDate, toDate, selectedFacility, selectedCompany]);

  const fetchGlobalData = async () => {
    try {
      let response = await get(
        `dashboard/globalEmission/wasteGeneratedMap?timeFrame=${month}&companyId=${selectedCompany?._id}`
      );
      setTableData(response?.data?.data);
      console.log("first45", response?.data?.data);
    } catch (error) {}
  };

  useEffect(() => {
    fetchGlobalData();
  }, [month, selectedCompany]);

  const fetchVendorList = async () => {
    try {
      const res = await get(
        `/dashboard/scope3/wastegenerated/vendorlist?facilities=${selectedFacility.join(
          ","
        )}&companyId=${selectedCompany?._id}`
      );
      setVendors(res?.data?.data.map((item) => item.vendorLegalName));
    } catch (err) {
      console.log(err);
    }
  };

  const fetchFacilityList = async () => {
    try {
      const res = await get(
        `/dashboard/scope3/purchasegoods/facilitylist?companyId=${selectedCompany?._id}`
      );
      setFacilities(res?.data?.data.map((item) => item.facilityName));
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchVendorList();
    fetchFacilityList();
  }, [selectedFacility, selectedCompany]);

  useEffect(() => {
    if (vendorList.length > 0) {
      setGraphView((prev) => ({
        ...prev,
        vendor: vendorList[0],
      }));
    }
  }, [vendorList, selectedCompany]);

  useEffect(() => {
    if (facilityList.length > 0) {
      setGraphView((prev) => ({
        ...prev,
        facility: facilityList[0],
      }));
    }
  }, [facilityList, selectedCompany]);

  const fetchFacilityData = async () => {
    try {
      if (graphView?.facility === "") return;
      // const res = await get(
      //   `/dashboard/scope3/wastegenerated/emission-facility?facility=${encodeURIComponent(
      //     graphView?.facility
      //   )}`
      // );
      const res = await get(
        `/dashboard/scope3/wastegenerated/emission-facility?facilities=${selectedFacility.join(
          ","
        )}&companyId=${selectedCompany?._id}`
      );
      setDashboardData((prev) => ({
        ...prev,
        emissionFacility: res?.data,
      }));
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchFacilityData();
  }, [selectedFacility, selectedCompany]);

  const fetchVendorData = async () => {
    try {
      if (graphView?.vendor === "") return;
      const res = await get(
        `/dashboard/scope3/wastegenerated/waste-managed/vendor?vendor=${encodeURIComponent(
          graphView?.vendor
        )}&facilities=${selectedFacility.join(",")}&companyId=${
          selectedCompany?._id
        }`
      );
      setDashboardData((prev) => ({
        ...prev,
        vendorWasteManaged: res?.data,
      }));
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchVendorData();
  }, [graphView?.vendor, selectedFacility, selectedCompany]);

  let emissionColors = [
    { label: "Hazardous Waste", color: "rgba(255, 79, 79, 1)" },
    { label: "Non-Hazardous Waste", color: "rgba(146, 0, 183, 1)" },
    { label: "Construction & Demolition Waste", color: "rgba(14, 98, 224, 1)" },
    { label: "Wastewater", color: "rgba(155, 155, 155, 1)" },
  ];

  let wasteTypeColors = [
    { label: "Hazardous Waste", color: "rgba(255, 79, 79, 1)" },
    { label: "Non-Hazardous Waste", color: "rgba(146, 0, 183, 1)" },
  ];

  let emissionDataSet = manipulateDataForBarChart({
    data: dashboardData?.emission?.emissionData,
    colors: emissionColors,
    type: "waste",
  });

  let wasteCategoryDataSet = generateBarChartDataSetForWaste(
    dashboardData?.wasteGenerated?.wasteGenerateQuantity,
    "rgba(0, 81, 183, 1)",
    "Waste Generated"
  );

  let monthlyWasteDataSet =
    dashboardData?.wasteGenerated?.monthlyData
      ?.map((el) => el?.totalWaste)
      ?.filter(Boolean)?.length > 0
      ? generateBarChartDataSetForWaste(
          dashboardData?.wasteGenerated?.monthlyData,
          "rgba(0, 102, 231, 1)",
          "Waste Generated"
        )
      : [];

  let wasteManagementDataSet = generateBarChartDataSetForWaste(
    dashboardData?.wasteManagement?.wasteManagement,
    "rgba(235, 126, 14, 1)",
    "Waste Management"
  );

  let wasteRecycledDataset = generateBarChartDataSetForWaste(
    dashboardData?.wasteRecycled?.wasteRecycled,
    "rgba(235, 126, 14, 1)",
    "Temporal Analysis"
  );

  let facilityDataset = manipulateDataForBarChart({
    data: dashboardData?.emissionFacility?.emissionFacility,
    colors: emissionColors,
    type: "facility",
  });

  let hasValidTotal = dashboardData?.vendorWasteManaged?.data?.some((entry) =>
    entry?.data?.some((d) => typeof d.total === "number" && d.total > 0)
  );

  let vendorDataset = hasValidTotal
    ? manipulateDataForBarChart({
        data: dashboardData?.vendorWasteManaged?.data,
        colors: emissionColors,
        type: "facility",
      })
    : [];

  let wasteTypeDiffDataset = manipulateDataForBarChart({
    data: dashboardData?.wasteType?.wasteTypeHazardousNonHazardous,
    colors: wasteTypeColors,
    type: "waste",
  });

  let temporalDataset =
    dashboardData?.temporalAnalysis?.yearWiseData
      ?.map((item) => {
        return item.totalEmissions;
      })
      ?.filter(Boolean)?.length > 0 ||
    dashboardData?.temporalAnalysis?.yearWiseData
      ?.map((item) => {
        return item.totalWaste;
      })
      ?.filter(Boolean)?.length > 0
      ? [
          {
            label: "Emission",
            data: dashboardData?.temporalAnalysis?.yearWiseData?.map((item) => {
              return item.totalEmissions;
            }),
            borderColor: "rgba(0, 102, 231, 1)",
            backgroundColor: "rgba(0, 102, 231, 0.6)",
            tension: 0.4,
            fill: true,
            pointBorderColor: "#fff",
            pointRadius: 0,
          },
          {
            label: "Waste Generated (Tonnes)",
            data: dashboardData?.temporalAnalysis?.yearWiseData?.map((item) => {
              return item.totalWaste;
            }),
            borderColor: "rgba(255, 187, 51, 1)",
            backgroundColor: "rgba(255, 187, 51, 0.6)",
            tension: 0.4,
            fill: true,
            pointBorderColor: "#fff",
            pointRadius: 0,
          },
        ]
      : [];

  let annualTemporalDataset =
    dashboardData?.temporalAnalysis?.currentYearData
      ?.map((item) => {
        return item.totalWaste;
      })
      ?.filter(Boolean)?.length > 0 ||
    dashboardData?.temporalAnalysis?.currentYearData
      ?.map((item) => {
        return item.totalEmissions;
      })
      ?.filter(Boolean)?.length > 0
      ? [
          {
            label: "Emission",
            data: dashboardData?.temporalAnalysis?.currentYearData?.map(
              (item) => {
                return item.totalEmissions;
              }
            ),
            borderColor: "rgba(0, 102, 231, 1)",
            backgroundColor: "rgba(0, 102, 231, 0.6)",
            tension: 0.4,
            fill: true,
            pointBorderColor: "#fff",
            pointRadius: 0,
          },
          {
            label: "Waste Generated (Tonnes)",
            data: dashboardData?.temporalAnalysis?.currentYearData?.map(
              (item) => {
                return item.totalWaste;
              }
            ),
            borderColor: "rgba(255, 187, 51, 1)",
            backgroundColor: "rgba(255, 187, 51, 0.6)",
            tension: 0.4,
            fill: true,
            pointBorderColor: "#fff",
            pointRadius: 0,
          },
        ]
      : [];

  const handleGraphChange = (e, type) => {
    if (type === "temporal") {
      setGraphView((prev) => ({ ...prev, temporal: e.target.value }));
    } else if (type === "facility") {
      setGraphView((prev) => ({ ...prev, facility: e.target.value }));
    } else if (type === "totalWaterRecycled") {
      setGraphView((prev) => ({ ...prev, totalWaterRecycled: e.target.value }));
    } else if (type === "vendor") {
      console.log("second1", e.target.value);
      setGraphView((prev) => ({ ...prev, vendor: e.target.value }));
    }
  };

  let facilityColors = ["#FF4C4C", "#007BFF", "#FFBB33", "#33FFBB"];

  console.log("first", dashboardData);
  console.log("second", graphView);

  return (
    <>
      <div className={styles.heading_container}>
        <p className={styles.heading}>Waste generated in operations</p>
        <PeriodFilter
          {...{
            fromDate,
            setFromDate,
            toDate,
            setToDate,
            yearList,
            setSelectedFacility,
            selectedFacility,
          }}
        />
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Emission Analysis</p>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>
                Emissions from Waste Management (tCO2e)
              </p>
              <p className={styles.graph_value}>
                {formatNumberCommaSeparated(
                  fixedPercentage(dashboardData?.emission?.totalEmission)
                )}
              </p>
            </div>
          </div>
          <BarChart
            datasets={emissionDataSet}
            labels={generateMonthArray(fromDate, toDate)}
            display={true}
          />
        </div>
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Waste Generation Analysis</p>
        <div className={styles.emission_container}>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <div>
                <p className={styles.graph_heading}>Total Quantity (Tonnes)</p>
                <p className={styles.graph_value}>
                  {formatNumberCommaSeparated(
                    fixedTons(
                      dashboardData?.wasteGenerated?.wasteGenerateQuantity.reduce(
                        (sum, field) => sum + Number(field?.totalWaste || 0),
                        0
                      )
                    )
                  )}
                </p>
              </div>
            </div>
            <BarChart
              datasets={wasteCategoryDataSet}
              labels={dashboardData?.wasteGenerated?.wasteGenerateQuantity?.map(
                (item) => {
                  return item?.categoryType;
                }
              )}
              display={true}
            />
          </div>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <div className={styles.graph_container_header}>
                <p className={styles.graph_heading}>
                  Waste Generation by Facility (Tonnes)
                </p>
              </div>
            </div>
            {dashboardData?.wasteGenerated?.wasteGeneratedByFacility
              ?.map((item) => {
                return item?.totalWaste;
              })
              ?.filter(Boolean)?.length > 0 ? (
              <>
                {" "}
                <div className={styles.doughnut_container}>
                  <EchartDoughnutChart
                    labels={dashboardData?.wasteGenerated?.wasteGeneratedByFacility?.map(
                      (item) => {
                        return item?.facility;
                      }
                    )}
                    dataPoints={dashboardData?.wasteGenerated?.wasteGeneratedByFacility?.map(
                      (item) => {
                        return item?.totalWaste;
                      }
                    )}
                    colors={facilityColors.slice(
                      0,
                      dashboardData?.wasteGenerated?.wasteGeneratedByFacility
                        .length
                    )}
                    legendPosition="top"
                    customWidth={"200px"}
                    customHeight={"200px"}
                    mt={"30%"}
                    hide={true}
                  />
                </div>
                <div className={styles.stationary_chart_container}>
                  <div className={styles.doughnut_table_div}>
                    {dashboardData?.wasteGenerated?.wasteGeneratedByFacility.map(
                      (item, index) => (
                        <div key={index} className={styles.table_container}>
                          <div className={styles.table_row}>
                            <span
                              className={styles.table_row_label}
                              style={{
                                backgroundColor: facilityColors[index],
                              }}
                            ></span>
                            <span className={styles.table_text}>
                              {item?.facility}
                            </span>
                          </div>
                          <span className={styles.table_text_val}>
                            {formatNumberCommaSeparated(
                              fixedPercentage(item?.totalWaste ?? 0)
                            )}
                          </span>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </>
            ) : (
              <NoDataFound mt={"30%"} />
            )}
          </div>
        </div>

        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>Monthly waste trends</p>
              {/* <p className={styles.graph_value}>80 Kg/Litre</p> */}
            </div>
          </div>
          <BarChart
            datasets={monthlyWasteDataSet}
            labels={generateMonthArray(fromDate, toDate)}
            display={true}
          />
        </div>
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Waste Type Analysis</p>

        <div className={styles.emission_container}>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <p className={styles.graph_heading}>
                Breakdown by Waste Type (Tonnes)
              </p>
            </div>
            <div className={styles.doughnut_container}>
              <EchartDoughnutChart
                labels={dashboardData?.wasteType?.wasteType?.map((item) => {
                  return item?.category;
                })}
                dataPoints={dashboardData?.wasteType?.wasteType?.map((item) => {
                  return item?.totalWaste;
                })}
                colors={facilityColors.slice(
                  0,
                  dashboardData?.wasteType?.wasteType.length
                )}
                legendPosition="top"
                customWidth={"175px"}
                customHeight={"175px"}
                mt={"35%"}
              />
            </div>
            <div className={styles.stationary_chart_container}>
              <div className={styles.doughnut_table_div}>
                {dashboardData?.wasteType?.wasteType.map((item, index) => (
                  <div key={index} className={styles.table_container}>
                    <div className={styles.table_row}>
                      <span
                        className={styles.table_row_label}
                        style={{
                          backgroundColor: facilityColors[index],
                        }}
                      ></span>
                      <span className={styles.table_text}>
                        {item?.category}
                      </span>
                    </div>
                    <span className={styles.table_text_val}>
                      {formatNumberCommaSeparated(
                        fixedPercentage(item?.totalWaste ?? 0)
                      )}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <div className={styles.graph_container_header}>
                <p className={styles.graph_heading}>
                  Hazardous vs. Non-Hazardous Waste
                </p>
              </div>
            </div>
            <BarChart
              datasets={wasteTypeDiffDataset}
              labels={generateMonthArray(fromDate, toDate)}
              display={true}
            />
          </div>
        </div>
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Waste Management Analysis</p>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>
                Waste Management Methods & Efficiency
              </p>
            </div>
          </div>
          <BarChart
            datasets={wasteManagementDataSet}
            labels={dashboardData?.wasteManagement?.wasteManagement.map(
              (item) => {
                return item.wasteManagementMethod;
              }
            )}
            yAxisTitle={" Efficiency of Waste Treatment (Tonnes)"}
            display={true}
          />
        </div>
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Geographical Analysis</p>

        <div className={styles.card_container_map}>
          <div className={styles.world_map_header_container}>
            <p className={styles.graph_heading}>Emission by Country</p>
            <div className={styles.input_date_loc_select_container}>
              <select
                name="month"
                id="month"
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                className={styles.heading_select_month}
              >
                {durationObj?.map((m) => (
                  <option key={m?.id} value={m?.id}>
                    {m?.label}
                  </option>
                ))}
              </select>

              {/* <select
                name="year"
                id="year"
                value={year}
                onChange={(e) => setYear(e.target.value)}
                className={styles.heading_select_year}
              >
                {["World"].map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select> */}
            </div>
          </div>

          <div className={styles.global_travel_container}>
            <div className={styles.global_travel_table}>
              <TableChart tableData={tableData} />
            </div>
            <div className={styles.global_travel_graph}>
              <GlobalChart tableData={tableData} />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Temporal Analysis</p>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>Year-over-Year Comparison</p>
            </div>
            <div>
              <select
                name="month"
                id="month"
                value={graphView.temporal}
                onChange={(e) => handleGraphChange(e, "temporal")}
                className={styles.heading_select_month}
              >
                {["Annual", "Year On Year"].map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <LineChart
            dataset={
              graphView?.temporal === "Annual"
                ? annualTemporalDataset
                : temporalDataset
            }
            labels={
              graphView?.temporal === "Annual"
                ? generateMonthArray(fromDate, toDate)
                : dashboardData?.temporalAnalysis?.yearWiseData?.map((item) => {
                    return item.year;
                  })
            }
          />
        </div>
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>
          Comparative and Benchmarking Analysis
        </p>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>Comparison of Facilities</p>
            </div>
            {/* <div>
              <select
                style={{ width: "150px" }}
                name="month"
                id="month"
                value={graphView.facility}
                onChange={(e) => handleGraphChange(e, "facility")}
                className={styles.heading_select_month}
              >
                {facilityList.map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
            </div> */}
          </div>
          <BarChart
            datasets={facilityDataset}
            labels={generateMonthArray(fromDate, toDate)}
            display={true}
          />
        </div>
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Vendor and Third-Party Analysis</p>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>
                Waste Sold to Third Parties (Tonnes)
              </p>
              {/* <p className={styles.graph_value}>80 Kg/Litre</p> */}
            </div>
            <div>
              <select
                style={{ width: "150px" }}
                name="month"
                id="month"
                value={graphView?.vendor}
                onChange={(e) => handleGraphChange(e, "vendor")}
                className={styles.heading_select_month}
              >
                {vendorList.map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <BarChart
            datasets={vendorDataset}
            labels={generateMonthArray(fromDate, toDate)}
            display={true}
          />
        </div>
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Circular Economy Initiatives</p>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <p className={styles.graph_heading}>Material Recovery</p>
          </div>
          <BarChart
            datasets={wasteRecycledDataset}
            labels={dashboardData?.wasteRecycled?.wasteRecycled?.map((item) => {
              return item.wasteCategory;
            })}
            display={true}
          />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
